<template>
  <div>

    <nav class="breadcrumb is-small has-dot-separator">
      <ul>
        <li>
          <b-icon icon="home" size="is-small" />
        </li>
        <li class="is-active"><a href="#">{{$t('pro-doc.message1')}}</a></li>
        <li class="is-active"><a href="#">{{$t('pro-doc.message2')}}</a></li>
      </ul>
    </nav>

    <h1 class="is-size-4">{{$t('pro-doc.message2')}}</h1>

    <div class="filters">

      <div class="search">
        <b-field>
          <b-input :placeholder="$t('pro-doc.message5')" type="search" icon="search" size="is-small" />
        </b-field>
      </div>

      <div v-for="filter in filters" :key="'filter' + filter.label" class="filter">
        <div class="name">{{ filter.label }} :</div>
        <b-dropdown>
          <button class="button is-full-width is-small is-light" slot="trigger">
            <span>{{$t('pro-doc.message3')}}</span>
            <b-icon icon="chevron-down" size="is-small" />
          </button>
          <b-dropdown-item>{{$t('pro-doc.message4')}}</b-dropdown-item>
        </b-dropdown>
      </div>

      <div style="clear: both" />

    </div>

    <b-table :data="items" :default-sort="['title', 'asc']" :mobile-cards="false">
      <template slot-scope="props">
        <b-table-column>
          <b-icon icon="file" size="is-small" pack="far" />
        </b-table-column>
        <b-table-column field="title" label="Nom" sortable>{{ props.row.title }}</b-table-column>
        <b-table-column field="nature" label="Nature" sortable>{{ props.row.nature }}</b-table-column>
        <b-table-column field="immeuble" label="Immeuble" sortable>{{ props.row.immeuble }}</b-table-column>
        <b-table-column field="enseigne" label="Enseigne" sortable>{{ props.row.enseigne }}</b-table-column>
        <b-table-column field="bail" label="Bail" sortable>{{ props.row.bail }}</b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import faker from 'faker'

const natureDocuments = [
  'Attestation de sinistralité DO',
  'Arrêté d\'autorisation',
  'Courrier de conformité tacite',
  'Imprimé de demande',
  'DOC',
  'DAACT',
  'Justificatif de levée des réserves (Autorisations)',
  'PV de levée des réserves',
  'Convention',
  'Contrat de franchise',
]

let items = []
for (let i = 0; i < 20; i++) {
  items.push({
    title: faker.lorem.sentence(),
    nature: faker.random.arrayElement(natureDocuments),
    enseigne: faker.company.companyName(),
    immeuble: faker.address.streetName(),
    bail: faker.random.alphaNumeric(6).toUpperCase(),
  })
}

const filters = [
  {
    label: 'Nature',
  },
  {
    label: 'Immeuble',
  },
  {
    label: 'Enseigne',
  },
  {
    label: 'Bail',
  },
]

export default {
  data () {
    return {
      filters,
      items,
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: .35em;
  font-weight: bold;
}

.filters {
  margin-bottom: 1.5em;

  .search {
    float: right;
    margin-top: 20px;
    width: 220px;
  }

  .filter {
    float: left;
    margin-right: 1.5em;
    margin-bottom: .5em;
  }

  .name {
    font-size: .75em;
    opacity: .7;
    margin-bottom: .1em;
  }
}

.b-table td {
  font-size: .9em;
}
</style>
